import React, { useState, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import "./Ourcompany.css";
import Nav from "../Nav/Nav";
import Transition from "../Transition/Transition";
import Projects from "../Projects/Projects";
import LogoLoader from "../Loading/Loading";
import Footer from "../Footer/Footer";
import projectGalleryData from "../../data/projectgallery.json";

const OurCompany = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const targetId = searchParams.get("targetId") || location.state?.targetId;
  const [galleryImage, setGalleryImage] = useState(null);

  useEffect(() => {
    if (projectGalleryData && projectGalleryData.length > 0) {
      const randomIndex = Math.floor(Math.random() * projectGalleryData.length);
      setGalleryImage(projectGalleryData[randomIndex]);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2650);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isLoading && targetId) {
      const timeout = setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el) {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [isLoading, targetId]);

  const [isAlbanian, setIsAlbanian] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage !== null ? JSON.parse(savedLanguage) : true;
  });

  const toggleLanguage = () => {
    setIsAlbanian((prev) => {
      const newLanguage = !prev;
      localStorage.setItem("language", JSON.stringify(newLanguage));
      return newLanguage;
    });
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <LogoLoader />
      </div>
    );
  }

  if (!galleryImage) {
    return <div>Error loading image</div>;
  }

  return (
    <>
      <div className="ourcompanyphoto-container-up">
        <Nav isAlbanian={isAlbanian} toggleLanguage={toggleLanguage} />

        <div className="ourcompanyphoto-container">
          <img
            src={galleryImage.gallery_image_url}
            alt="ourcompany-photo"
            className="ourcompany-image"
          />
          <div className="overlay">
            <div className="vertical-line left"></div>
            <div className="vertical-line right"></div>
            <div className="hero-title">
              <h1 className="overlay-text">
                {isAlbanian ? (
                  <>
                    Inovacion në ndërtim,
                    <br />
                    <strong>
                      <span className="ourcompany-protest-font">cilësi</span>
                      <img
                        src="/underlined2-1.png"
                        alt="Underline decoration"
                        className="underline-image"
                      />
                    </strong>{" "}
                    deri në detaje
                  </>
                ) : (
                  <>
                    Building that <br />
                    <strong>
                      <span className="ourcompany-protest-font">stands</span>
                      <img
                        src="/underlined2-1.png"
                        alt="Underline decoration"
                        className="underline-image"
                      />
                    </strong>{" "}
                    the test of time
                  </>
                )}
              </h1>
            </div>
            <div className="bottom-line"></div>
          </div>
        </div>

        <div id="projects">
          <Projects isAlbanian={isAlbanian} />
        </div>

        <Transition isAlbanian={isAlbanian} />
      </div>

      <Footer isAlbanian={isAlbanian} />
    </>
  );
};

export default OurCompany;
